import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Route, Routes, NavLink } from "react-router-dom";
import "./../Dashboard.css";
import PATT from "./../icons/PATTSVG.svg";
import Marsh from "./../icons/register.svg";
import Frame from "./../icons/Frame.svg";
import Main from "./../icons/main.svg";
import Stats from "./../icons/Stats.svg";
import Team from "./../icons/team.svg";
import Logout from "./../icons/logout.svg";
import Menu from "./../icons/menu.svg";
import Report from "./../icons/Report.svg";
import AdminOverview from "./AdminComp/AdminOverview";
import AdminTeamManagement from "./AdminComp/AdminTeamManagement";
import AdminEventStats from "./AdminComp/AdminEventStats";
import AdminUploadEvent from "./AdminComp/AdminUploadEvent";
import ClubOwnerOverview from "./ClubOwnerComp/ClubOwnerOverview";
import ClubOwnerManagement from "./ClubOwnerComp/ClubOwnerTeamManagement";
import ClubOwnerStats from "./ClubOwnerComp/ClubOwnerEventStats";
import ClubOwnerEvent from "./ClubOwnerComp/ClubOwnerUploadEvent";
import UserOverview from "./UserComp/UserOverview";
import UserManagement from "./UserComp/UserTeamManagement";
import UserStats from "./UserComp/UserEventStats";
import UserEvent from "./UserComp/UserUploadEvent";
import { useNavigate } from "react-router-dom";
import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { Link } from "react-router-dom";
import ForgotPassword from "./ForgotPassword";
import ReportComp from "../components/ReportComp/ReportComp.js";
import SignUp from "./SignUp";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import Wallet from "../components/Wallet/Wallet";
import walletIcon from "../icons/wallet.svg";
import UserProfilePage from "../pages/Userprofile/UserProfilePage";

const Dashboard = () => {
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState(null);
  const [authenticated, setAuthenticated] = useState(false);
  const [clubIds, setClubIds] = useState([]);
  const [adminId, setAdminId] = useState(null);
  const [authentication, setAuthentication] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [user, setUser] = useState([]);
  const [profile, setProfile] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => setUser(codeResponse),
    onError: (error) => console.log("Login Failed:", error)
  });

  const containerRef = useRef(null);
  useEffect(() => {
    // Check if the user is authenticated and there's no valid route in the location
    if (
      authenticated &&
      (location.pathname === "/" || location.pathname === "")
    ) {
      switch (userRole) {
        case "Admin":
          navigate("/overview");
          break;
        case "Clubowner":
          navigate("/overview");
          break;
        case "User":
          navigate("/events-details");
          break;
        default:
          navigate("/"); // Default to login page if no role is found
      }
    }
  }, [authenticated, userRole, location, navigate]);
  // Function to toggle the sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  const handleLogout = () => {
    setAuthenticated(false);
    setUserRole(null);
    setClubIds([]);
    setAdminId(null);
    console.log("User logged out");

    localStorage.removeItem("authenticated");
    localStorage.removeItem("userRole");
    localStorage.removeItem("clubIds");
    localStorage.removeItem("adminId");
    localStorage.removeItem("name");
    localStorage.removeItem("events_organising_ids");
    localStorage.removeItem("events");
    localStorage.removeItem("phoneNumber");
    navigate("/");
  };

  useEffect(() => {
    const savedUserRole = localStorage.getItem("userRole");
    const savedClubIds = JSON.parse(localStorage.getItem("clubIds") || "[]");
    const savedAdminId = localStorage.getItem("adminId");
    const isAuthenticated = localStorage.getItem("authenticated") === "true";

    if (isAuthenticated) {
      setAuthenticated(isAuthenticated);
      setUserRole(savedUserRole);
      setClubIds(savedClubIds);
      setAdminId(savedAdminId);
    }
  }, []);

  const handleLogin = async (e) => {
    console.log("Login button pressed, starting request...");
    setLoading(true); // Start loading
    e.preventDefault();
    try {
      console.log("BACKEND URL : ", BACKEND_URL);
      const response = await axios.post(`${BACKEND_URL}/admin/login`, {
        authentication,
        password
      });
      console.log("Response received:", response);

      // Check the response status
      if (response.status === 200) {
        const data = response.data;
        const role =
          data.secretAdminToken === "ADMINUSER"
            ? "Admin"
            : data.secretAdminToken === "Clubowner"
              ? "Clubowner"
              : "User";

        // Update state and localStorage
        setAuthenticated(true);
        setUserRole(role);
        setClubIds(data.clubIds || []);
        setAdminId(data.adminId);
        localStorage.setItem("authenticated", "true");
        localStorage.setItem("userRole", role);
        localStorage.setItem("clubIds", JSON.stringify(data.clubIds || []));
        localStorage.setItem("adminId", data.adminId);
        localStorage.setItem("name", data.name);
        localStorage.setItem("events", JSON.stringify(data.events));
        localStorage.setItem("phoneNumber", data.phoneNumber);
        localStorage.setItem(
          "events_organising_ids",
          data.events_organising_ids
        );
        localStorage.setItem("token", data.token);

        navigate("/events-details");
      } else {
        console.log("Login failed with status:", response.status);
        setLoginError("Login failed. Please check your credentials.");
      }
    } catch (error) {
      console.error("Error during login:", error);
      setLoginError("Login failed. Please check your credentials.");
    } finally {
      setLoading(false); // End loading
    }
  };

  const responseMessage = async (response) => {
    try {
      const decodedToken = jwtDecode(response.credential);
      const { email, name } = decodedToken;
      const backendResponse = await axios.post(`${BACKEND_URL}/admin/login`, {
        authentication: response.credential,
        password: "",
        isGoogleLogin: true
      });

      if (backendResponse.status === 200) {
        const data = backendResponse.data;
        const role =
          data.secretAdminToken === "ADMINUSER"
            ? "Admin"
            : data.secretAdminToken === "Clubowner"
              ? "Clubowner"
              : "User";

        setAuthenticated(true);
        setUserRole(role);
        setClubIds(data.clubIds || []);
        setAdminId(data.adminId);
        localStorage.setItem("authenticated", "true");
        localStorage.setItem("userRole", role);
        localStorage.setItem("clubIds", JSON.stringify(data.clubIds || []));
        localStorage.setItem("adminId", data.adminId);
        localStorage.setItem("name", data.name);
        localStorage.setItem("events", JSON.stringify(data.events));
        localStorage.setItem(
          "events_organising_ids",
          data.events_organising_ids
        );
        localStorage.setItem("token", data.token);

        navigate("/events-details");
      } else {
        setLoginError("Login failed. Please check your credentials.");
      }
    } catch (error) {
      console.error("Google Login Error: ", error);
      setLoginError("Google login failed. Please try again.");
    }
  };

  const errorMessage = (error) => {
    console.log("Google Login Error: ", error);
    setLoginError("Google login failed. Please try again.");
  };
  const renderSideNav = () => {
    const baseLinkStyle = {
      display: "flex",
      alignItems: "center",
      textDecoration: "none",
      marginBottom: "15%"
    };

    const getNavLinkStyle = ({ isActive }) => ({
      ...baseLinkStyle,
      color: isActive ? "#FFFFFF" : "#A0A0A0"
    });

    return (
      <>
        {userRole === "Admin" && (
          <>
            <NavLink
              to="/overview"
              style={getNavLinkStyle}
              onClick={toggleSidebar}
            >
              <img src={Main} style={{ marginRight: "10px" }} alt="Overview" />
              Overview
            </NavLink>
            <NavLink
              to="/events-details"
              style={getNavLinkStyle}
              onClick={toggleSidebar}
            >
              <img
                src={Stats}
                style={{ marginRight: "10px" }}
                alt="Events Details"
              />
              Events Details
            </NavLink>
            <NavLink
              to="/report"
              style={getNavLinkStyle}
              onClick={toggleSidebar}
            >
              <img
                src={Report}
                style={{ marginRight: "10px", width: "30px", height: "30px" }}
                alt="Report"
              />
              Report
            </NavLink>
            <NavLink
              to="/team-management"
              style={getNavLinkStyle}
              onClick={toggleSidebar}
            >
              <img
                src={Team}
                style={{ marginRight: "10px" }}
                alt="Team Management"
              />
              Team Management
            </NavLink>
            <NavLink
              to="/upload-events"
              style={getNavLinkStyle}
              onClick={toggleSidebar}
            >
              <img
                src={Frame}
                style={{ marginRight: "10px" }}
                alt="Upload Events"
              />
              Upload Events
            </NavLink>
          </>
        )}

        {userRole === "Clubowner" && (
          <>
            <NavLink
              to="/overview"
              style={getNavLinkStyle}
              onClick={toggleSidebar}
            >
              <img src={Main} style={{ marginRight: "10px" }} alt="Overview" />
              Overview
            </NavLink>
            <NavLink
              to="/events-details"
              style={getNavLinkStyle}
              onClick={toggleSidebar}
            >
              <img
                src={Stats}
                style={{ marginRight: "10px" }}
                alt="Events Details"
              />
              Events Details
            </NavLink>
            <NavLink
              to="/wallet"
              style={getNavLinkStyle}
              onClick={toggleSidebar}
            >
              <img
                src={walletIcon}
                style={{ marginRight: "10px", width: "30px", height: "30px" }}
                alt="Wallet"
              />
              Wallet
            </NavLink>
            <NavLink
              to="/report"
              style={getNavLinkStyle}
              onClick={toggleSidebar}
            >
              <img
                src={Report}
                style={{ marginRight: "10px", width: "30px", height: "30px" }}
                alt="Report"
              />
              Report
            </NavLink>
            <NavLink
              to="/team-management"
              style={getNavLinkStyle}
              onClick={toggleSidebar}
            >
              <img
                src={Team}
                style={{ marginRight: "10px" }}
                alt="Team Management"
              />
              Team Management
            </NavLink>
            <NavLink
              to="/upload-events"
              style={getNavLinkStyle}
              onClick={toggleSidebar}
            >
              <img
                src={Frame}
                style={{ marginRight: "10px" }}
                alt="Upload Events"
              />
              Upload Events
            </NavLink>
          </>
        )}

        {userRole === "User" && (
          <>
            <NavLink
              to="/events-details"
              style={getNavLinkStyle}
              onClick={toggleSidebar}
            >
              <img
                src={Stats}
                style={{ marginRight: "10px" }}
                alt="My Events"
              />
              My Events
            </NavLink>
            <NavLink
              to="/report"
              style={getNavLinkStyle}
              onClick={toggleSidebar}
            >
              <img
                src={Report}
                style={{ marginRight: "10px", width: "30px", height: "30px" }}
                alt="Report"
              />
              Report
            </NavLink>
          </>
        )}
      </>
    );
  };

  const renderRoutes = () => {
    switch (userRole) {
      case "Admin":
        return (
          <>
            <Route path="/overview" element={<AdminOverview />} />

            <Route path="/events-details" element={<AdminEventStats />} />
            <Route
              path="/events-details/:viewMode/:eventId?"
              element={<AdminEventStats />}
            />
            <Route
              path="/events-details/:viewMode"
              element={<AdminEventStats />}
            />
            <Route path="/report" element={<ReportComp />} />

            <Route path="/team-management" element={<AdminTeamManagement />} />
            <Route path="/upload-events" element={<AdminUploadEvent />} />
            <Route path="/user-profile" element={<UserProfilePage />} />
          </>
        );
      case "Clubowner":
        return (
          <>
            <Route path="/overview" element={<ClubOwnerOverview />} />
            <Route path="/events-details" element={<ClubOwnerStats />} />
            <Route
              path="/events-details/:viewMode/:eventId?"
              element={<ClubOwnerStats />}
            />
            <Route
              path="/events-details/:viewMode"
              element={<ClubOwnerStats />}
            />
            <Route path="/wallet" element={<Wallet />} />
            <Route path="/report" element={<ReportComp />} />
            <Route path="/team-management" element={<ClubOwnerManagement />} />
            <Route path="/upload-events" element={<ClubOwnerEvent />} />
            <Route path="/user-profile" element={<UserProfilePage />} />
          </>
        );
      case "User":
        return (
          <>
            <Route path="/overview" element={<UserOverview />} />
            <Route path="/events-details" element={<UserStats />} />
            <Route
              path="/events-details/:viewMode/:eventId?"
              element={<UserStats />}
            />
            <Route path="/events-details/:viewMode" element={<UserStats />} />
            <Route path="/report" element={<ReportComp />} />
            <Route path="/team-management" element={<UserManagement />} />
            <Route path="/upload-events" element={<UserEvent />} />
            <Route path="/user-profile" element={<UserProfilePage />} />
          </>
        );
      default:
        return (
          <>
            <Route path="/" element={<div>Please log in</div>} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/login" element={<SignUp />} />
          </>
        );
    }
  };

  if (!authenticated) {
    return (
      <div className="container" ref={containerRef}>
        <div className="forms-container">
          <div className="signin-signup">
            <Routes>
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/login" element={<SignUp />} />
              <Route
                path="/*"
                element={
                  <form onSubmit={handleLogin} className="sign-in-form">
                    <h2 className="title">Sign in</h2>
                    <div className="input-field">
                      <i className="fas fa-user" />
                      <input
                        type="text"
                        placeholder="Username"
                        value={authentication}
                        onChange={(e) => setAuthentication(e.target.value)}
                      />
                    </div>
                    <div className="input-field">
                      <i className="fas fa-lock" />
                      <input
                        type={isPasswordVisible ? "text" : "password"}
                        placeholder="Password"
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <button
                        onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                        type="button"
                      >
                        {isPasswordVisible ? (
                          <i className="fas fa-eye-slash" />
                        ) : (
                          <i className="fas fa-eye" />
                        )}
                      </button>
                    </div>
                    {loginError && (
                      <div style={{ color: "red" }}>{loginError}</div>
                    )}
                    <Link style={{ marginBottom: "2%" }} to="/forgot-password">
                      Forgot Password
                    </Link>
                    <GoogleLogin
                      onClick={() => login()}
                      onSuccess={responseMessage}
                      onError={errorMessage}
                    />
                    {loading ? (
                      <Spin
                        indicator={<LoadingOutlined spin />}
                        size="large"
                        style={{ marginTop: "15px", marginBottom: "15px" }}
                      />
                    ) : (
                      // Display spinner when loading
                      <input
                        style={{ marginTop: "2%" }}
                        type="submit"
                        value="Login"
                        className="btn solid"
                      />
                    )}
                  </form>
                }
              />
            </Routes>
          </div>
        </div>
        <div className="panels-container">
          <div className="panel left-panel">
            <img
              src={PATT}
              style={{
                width: "60%",
                height: "auto",
                objectFit: "contain",
                marginTop: "30%",
                marginBottom: "30%"
              }}
              alt="React Logo"
              className="image"
            />
            <div className="content">
              <p>Welcome to the PATT Dashboard!</p>
              <h3 style={{ marginBottom: "20px" }}>
                Start the process and sign in to your account
              </h3>
              <Link
                className="btn transparent"
                id="sign-up-btn"
                to="/login"
                onClick={() =>
                  containerRef.current.classList.add("sign-up-mode")
                }
              >
                Sign up
              </Link>
            </div>
            <img src="/log.svg" className="image" alt="" />
          </div>
          <div className="panel right-panel">
            <img
              src={PATT}
              style={{
                width: "60%",
                height: "auto",
                objectFit: "contain",
                marginTop: "30%",
                marginBottom: "30%"
              }}
              className="image"
            />
            <div className="content">
              <h3 style={{ marginBottom: "20px" }}>ALREADY HAVE AN ACCOUNT?</h3>
              <Link
                className="btn transparent ls"
                id="sign-in-btn"
                to="/"
                onClick={() =>
                  containerRef.current.classList.remove("sign-up-mode")
                }
              >
                Sign in
              </Link>
            </div>
            <img src={Marsh} className="image" alt="" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div
        className="sidebar-toggle"
        onClick={toggleSidebar}
        style={{
          justifyContent: "center",
          alignItems: "center",
          color: "white",
          zIndex: 9999,
          borderRadius: "20%"
        }}
      >
        <img
          src={Menu}
          style={{
            justifyContent: "center",
            alignItems: "center",
            alignSelf: "center",
            marginBottom: "10%",
            marginTop: "17%",
            marginLeft: "30%",
            marginRight: "30%",
            width: "40%",
            height: "40%"
          }}
          alt="React Logo"
        />
      </div>
      <div className={`side-nav ${isSidebarVisible ? "visible" : ""}`}>
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <img
            src={PATT}
            style={{
              width: "60%",
              height: "auto",
              objectFit: "contain",
              marginTop: "30%",
              marginBottom: "30%"
            }}
            alt="React Logo"
          />
        </div>
        {renderSideNav()}
        <div
          onClick={handleLogout}
          style={{
            color: "white",
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
            color: "#FFFFFF",
            bottom: "0%"
          }}
        >
          <img src={Logout} style={{ marginRight: "10px" }} alt="React Logo" />
          Logout
        </div>
      </div>
      <div className="main-content">
        <Routes>{renderRoutes()}</Routes>
      </div>
    </div>
  );
};

export default Dashboard;
